/* --------------------------------------------
HappyNewYear!
-------------------------------------------- */
import * as Vivus from 'vivus';
import anime from 'animejs/lib/anime.es.js';

let moveObj_01 = $("#moveObject_01");
let moveObj_02 = $("#moveObject_02");
let animeObj = $('#animeObject');
let moveObj = $('#moveObject object');

export function mainAnimationFunc() {
  function loaderFunc() {
    $('#loader').addClass('hide');
  }

  function moveAnimationFunc() {
    let move_01 = new Vivus('moveObject_01', {
      type: 'oneByOne',
      animTimingFunction: Vivus.EASE,
      start: 'autostart',
    }, function (obj) {
      moveObj_01.attr("class", "finished");
      setTimeout(function () {
        if (moveObj_01.hasClass('finished')) {
          moveObj_01.css('opacity', '0');
          setTimeout(() => {
            moveObj_01.removeClass('finished');
            moveObj_01.css('opacity', '1');
            move_01.reset().play(1);
          }, 1200);
        }
      }, 2000);
    });
    setTimeout(function () {
      moveObj_02.css('opacity', '1');
      let move_02 = new Vivus('moveObject_02', {
        animTimingFunction: Vivus.EASE,
        start: 'autostart',
      }, function (obj) {
        moveObj_02.attr("class", "finished");
        setTimeout(function () {
          if (moveObj_02.hasClass('finished')) {
            move_02.play(-1);
            setTimeout(() => {
              moveObj_02.removeClass('finished');
              move_02.reset().play(1);
            }, 1200);
          }
        }, 3000);
      });
    }, 1000);
  }

  function showFunc() {
    animeObj.css('opacity', '0');
    moveObj.css('opacity', '1');
    setTimeout(function () {
      moveObj.addClass('move');
      moveObj_01.css('opacity', '0');
    }, 2000);
    setTimeout(function () {
      moveObj_01.css('opacity', '1');
      moveObj_02.css('opacity', '0');
      moveAnimationFunc();
    }, 3000);
  }

  function lineAnimationFunc() {
    setTimeout(function () {
      animeObj.css('opacity', '1');
      new Vivus('animeObject', {
        delay: 100,
        duration: 150,
        animTimingFunction: Vivus.EASE,
        start: 'autostart',
      }, function (obj) {
        showFunc();
        textAnimationFunc();
      });
    }, 500);
  }

  function textAnimationFunc() {
    $('#happyNewYear').addClass('active');
  }

  anime({
    targets: '#loader',
    opacity: {
      value: [1, 0],
      delay: 500,
      duration: 500,
      easing: 'easeInQuint',
    },
    complete: function () {
      loaderFunc();
      lineAnimationFunc();
    }
  });
}

export function contentFadeInFunc() {
  $('.inView').on('inview', function () {
    let obj = $(this);
    setTimeout(function () {
      $(obj).addClass('fadeIn');
    }, 1000);
  });
}